/**
 * Build-time gate for the public MotionPace marketing surface (#544).
 *
 * NOT the same switch as the in-app feature. The editor's MotionPace controls
 * are gated by `config/featureFlags.motionPace`, a Firestore document read at
 * runtime — which cannot gate this page, because the flags doc requires
 * authentication and /motionpace exists to be read by signed-out visitors and
 * by crawlers that never run JavaScript. So the marketing page is gated at
 * BUILD time, and the two switches are flipped together at launch.
 *
 * Mirrors `motionPaceMarketingEnabled()` in scripts/prerender.routes.js, which
 * applies the same variable to the prerender manifest, the sitemap and
 * llms.txt. Both read the same env var so one flip lights everything.
 *
 * A literal comparison rather than a truthiness check on purpose: CRA inlines
 * `process.env.REACT_APP_*` as a string at build time, so `=== 'true'` folds to
 * a constant the minifier can use to drop the route entirely.
 */
export const MOTIONPACE_MARKETING_FLAG = 'REACT_APP_MOTIONPACE_MARKETING';

export const MOTIONPACE_MARKETING_ENABLED =
  process.env.REACT_APP_MOTIONPACE_MARKETING === 'true';
